<div class="header">
  <h2 class="title">
    <div class="mobile-prefix">
      <a
        tabindex="0"
        class="mobile-back-button"
        ixTest="disk-details-back"
        (click)="onCloseMobileDetails()"
        (keydown.enter)="onCloseMobileDetails()"
      >
        <ix-icon name="mdi-chevron-left"></ix-icon>
      </a>
      {{ 'Details' | translate }}
    </div>

    <span class="prefix">{{ 'Details' | translate }}</span>
  </h2>
</div>

<div *ngIf="app" class="cards">
  <div class="scroll-window">
    <ix-app-info-card
      [app]="app"
      [status]="status"
      (startApp)="startApp.emit()"
      (stopApp)="stopApp.emit()"
    ></ix-app-info-card>
    <ix-app-containers-card [app]="app"></ix-app-containers-card>
    <ix-app-history-card [app]="app"></ix-app-history-card>
    <ix-app-notes-card *ngIf="app.info?.notes" [app]="app"></ix-app-notes-card>
    <ix-app-metadata-card
      *ngIf="app?.app_metadata"
      [appMetadata]="app.app_metadata"
      [maxHeight]="180"
    ></ix-app-metadata-card>
  </div>
</div>
